/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowShapeTriangleAUpIcon16Light = forwardRef('ArrowShapeTriangleAUpIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3.922 12a1 1 0 0 1-.838-1.545l4.03-6.194a1 1 0 0 1 1.671-.008l4.115 6.194A1 1 0 0 1 12.068 12H3.922Zm4.03-7.193L3.922 11h8.146L7.952 4.807Z" })));
});
